/**
 * Copyright (c) 2022 Strategio Digital s.r.o.
 * @author Jiří Zapletal (https://strategio.digital, jz@strategio.digital)
 */

const pbDateToObject = (dateTime: string): Date => {
    const [date, time] = dateTime.split(' ')
    return new Date(`${date}T${time}`)
}

const toCzechDateString = (date: Date): string => {
    return `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()}`
}

const toCzechDateTimeString = (date: Date): string => {
    const hours = date.getHours() < 9 ? `0${date.getHours()}` : date.getHours()
    const minutes = date.getMinutes() < 9 ? `0${date.getMinutes()}` : date.getMinutes()
    const seconds = date.getSeconds() < 9 ? `0${date.getSeconds()}` : date.getSeconds()

    return `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()} ${hours}:${minutes}:${seconds}`
}

const isValidCzechDate = (czechDate: string): boolean => {
    const czd = czechDate.replaceAll(' ', '')
    const regex = /^([1-9]|1[0-9]|2[0-9]|3[0-1])\.([1-9]|1[0-2])\.([0-2][0-9]{3})$/gm
    return regex.test(czd)
}

const isValidCzechDateTime = (czechDate: string): boolean => {
    const czd = czechDate.replaceAll(' ', '')
    const regex = /^([1-9]|1[0-9]|2[0-9]|3[0-1])\.([1-9]|1[0-2])\.([0-2][0-9]{3})(0[0-9]|1[0-9]|2[0-3])(\:(0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])){2}$/gm
    return regex.test(czd)
}

const czechDateToObject = (czechDate: string): Date => {
    if (! isValidCzechDate(czechDate)) {
        throw 'Date is not in valid Czech format'
    }

    let [day, month, year] = czechDate.replaceAll(' ', '').split('.')
    day = parseInt(day) < 10 ? '0' + day : day
    month = parseInt(month) < 10 ? '0' + month : month

    return new Date(`${year}-${month}-${day}`)
}

const czechDateTimeToObject = (czechDate: string): Date => {
    if (! isValidCzechDateTime(czechDate)) {
        throw 'DateTime is not in valid Czech format'
    }

    const normalized = czechDate.replaceAll(/\040|\.|\:/gm, '-').replaceAll('--', '-')
    let [day, month, year, hour, minute, second] = normalized.split('-')

    day = parseInt(day) < 10 ? '0' + day : day
    month = parseInt(month) < 10 ? '0' + month : month

    return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`)
}

export const timeHelper = () => {
    return {
        pbDateToObject,
        czechDateToObject,
        czechDateTimeToObject,
        isValidCzechDate,
        isValidCzechDateTime,
        toCzechDateString,
        toCzechDateTimeString
    }
}